/**
 * Created by mateimisarca on 2019-06-07
 */

import Testimonials from './testimoniale';
export default Testimonials;
